import React, { useEffect, useMemo, useState } from 'react'
import { BarDuplicate as Bar, Rose } from '@ow/charts/lib'
import { Table, Loader } from '@mantine/core'
import { isArray } from 'lodash-es'

// 目前只考虑了柱状图、折线图、饼状图
// const defaultRemote = {
//   api: 'fetch',
//   url: null,
//   opts: {},
// }

// 处理一下数据，（兼容下国际项目数据...)
const dealData = (data = {}) => {
  if (!data.content || isArray(data)) {
    return (data || []).map((item) => {
      const obj = {}
      if (item.data) {
        item.data.forEach((v) => {
          obj[v.name || v.slug] = v.value
          return obj
        })
      }
      return { ...item, ...obj }
    })
  }
  return data.content || []
}
const Index = function ({ defs = {}, fields, rowData, hooks = {} }) {
  const { onFetchRemoteData } = hooks
  const {
    slug,
    title,
    showTable,
    renderValue,
    statisticsBySlug: statisticsBy = {},
    statisticsFields,
    remote = {},
  } = defs

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [currentPieDataIndex, setCurrentPieDataIndex] = useState(0)
  const defaultParams = (rowData[slug] && rowData[slug].params) || {}
  const statisticsBySlug = statisticsBy.slug

  const finalRemote = {
    ...remote,
    opts: {
      params: {
        ...((remote && remote.opts && remote.opts.params) || {}),
        ...defaultParams,
      },

      transform: remote && remote.opts && remote.opts.transform,
      method: 'post',
    },
  }

  // 纵向柱状图数据
  const barSeriesData = useMemo(() => {
    return statisticsFields
      .filter((v) => ['bar', 'line'].includes(v.type))
      .map((v) => {
        const arr = data.map((d) => {
          return d[v.title || v.slug] || 0
        })
        return { ...v, data: arr, name: v.title }
      })
  }, [data, statisticsFields])

  // 水平柱状图数据
  const horizontalSeriesData = useMemo(() => {
    return statisticsFields
      .filter((v) => ['line-bar'].includes(v.type))
      .map((v) => {
        const arr = data.map((d) => {
          return d[v.title || v.slug] || 0
        })
        return { ...v, data: arr, name: v.title, type: 'bar' }
      })
  }, [data, statisticsFields])

  // 饼状图数据
  const pieData = useMemo(() => {
    const slugs = statisticsFields
      .filter((v) => v.type === 'pie')
      .map((v) => v.slug || v.title)

    if (slugs.length > 0) {
      return data.map((v) => {
        // const obj = omit(v, [statisticsBySlug])
        const arr = slugs.map((s) => {
          return { value: v[s], name: s }
        })
        return { [statisticsBySlug]: v[statisticsBySlug], data: arr }
      })
    }
    return []
  }, [data, statisticsFields])

  // 柱状图x轴数据
  const xAxisData = useMemo(() => {
    return data.map((v) => v[statisticsBySlug])
  }, [data])

  // 柱状图y轴数据
  const yAxisData = useMemo(() => {
    return barSeriesData.map((d) => {
      return d.name
    })
  }, [barSeriesData])

  const allCloumns = useMemo(() => {
    const byField = fields.find((v) => v.slug === statisticsBySlug)
    const firstCloumns = byField || statisticsBy
    const others = statisticsFields.map((v) => {
      if (v.title) {
        return v
      }
      return fields.find((f) => f.slug === v.slug) || {}
    })
    return [firstCloumns, ...others].filter((v) => v)
  }, [data])

  useEffect(() => {
    setLoading(true)
    // 使用remote获取定制接口的数据
    if (onFetchRemoteData && remote && finalRemote.api) {
      // 如果配置了api,走extend请求定制接口

      const extend = onFetchRemoteData('extend')

      extend[finalRemote.api](finalRemote.url, finalRemote.opts).then((res) => {
        setData(res)
        setLoading(false)
      })
    } else if (isArray(rowData[slug]) || renderValue) {
      // const { content } = rowData[slug] || {}
      setData(dealData(rowData[slug] || {}))
      setLoading(false)
    } else {
      setLoading(false)
    }
  }, [rowData])

  return (
    <div className="h-full w-full flex flex-col items-center">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="w-full flex flex-col flex-1">
            {/* 纵向柱状图 */}
            {barSeriesData.length > 0 && (
              <Bar
                id={`${slug}statistics`}
                width="100%"
                height="100%"
                xAxisData={xAxisData}
                yAxisData={yAxisData}
                seriesData={barSeriesData}
                name={title}
                colors={['#5B8FF9', '#EFBD2A', '#32CC7B', '#F63C54']}
                dataZoom={{
                  show: false,
                  orient: 'horizontal',
                }}
                // interval={1}
                axisLabel={{
                  rotate: xAxisData.length > 10 ? 40 : 0,
                  interval: 1,
                }}
              />
            )}
            {horizontalSeriesData.length > 0 && (
              <Bar
                id={`${slug}statistics-horizontal`}
                width="100%"
                height="100%"
                xAxisData={null}
                yAxisData={xAxisData}
                seriesData={horizontalSeriesData}
                name={title}
                colors={['#5B8FF9', '#EFBD2A', '#32CC7B', '#F63C54']}
                type="horizontal"
                dataZoom={{
                  show: false,
                  orient: 'vertical',
                }}
              />
            )}
            {pieData && pieData.length > 0 && pieData[currentPieDataIndex] && (
              <div className="h-full flex w-full items-center justify-center gap-2 flex-col mb-5">
                <Rose
                  width="100%"
                  height="100%"
                  id={`${currentPieDataIndex + 1}-pie`}
                  data={pieData[currentPieDataIndex].data}
                  showLabel={false}
                  radius={[0, '70%']}
                  colors={['#5B8FF9', '#EFBD2A', '#32CC7B', '#F63C54']}
                  legend={{
                    orient: 'vertical',
                    right: 0,
                    itemWidth: 14,
                    itemHeight: 14,
                    itemLineHeight: 14,
                    textStyle: {
                      fontSize: 14,
                      color: 'var(--ow-color-primary-700)',
                      // color: 'rgba(234, 237, 255, 0.9)',
                    },
                  }}
                />
                <div className="w-full flex relative items-center justify-center">
                  {pieData[currentPieDataIndex] && (
                    <span>
                      {pieData[currentPieDataIndex][statisticsBySlug]}
                    </span>
                  )}
                  <div className="flex items-center justify-center absolute right-20">
                    <span
                      title="上一个"
                      onClick={() => {
                        setCurrentPieDataIndex(
                          currentPieDataIndex === 0
                            ? 0
                            : currentPieDataIndex - 1
                        )
                      }}
                      className="cursor-pointer w-8 h-8 flex items-center justify-center dark:hover:bg-darkTheme-900"
                      style={{ borderRadius: '4px' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-chevron-left cursor-pointer"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <polyline points="15 6 9 12 15 18" />
                      </svg>
                    </span>
                    <span
                      title="下一个"
                      onClick={() => {
                        setCurrentPieDataIndex(
                          currentPieDataIndex === pieData.length - 1
                            ? currentPieDataIndex
                            : currentPieDataIndex + 1
                        )
                      }}
                      className="cursor-pointer w-8 h-8 flex items-center justify-center dark:hover:bg-darkTheme-900"
                      style={{ borderRadius: '4px' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-chevron-right cursor-pointer"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <polyline points="9 6 15 12 9 18" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {showTable === 'show' && (
            <div className="w-full">
              <div
                className="pl-2 h-4 flex w-full"
                style={{
                  borderLeft: 'solid 4px rgb(var(--ow-primary-color))',
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                  marginBottom: '1.5rem',
                }}
              >
                数据表
              </div>
              <Table
                className="w-full relative"
                fontSize="sm"
                verticalSpacing="xs"
              >
                <thead
                  style={{
                    width: '100%',
                    position: 'sticky',
                    top: '0',
                    left: '0',
                  }}
                >
                  <tr style={{ width: '100%' }}>
                    {allCloumns.map((v) => {
                      return (
                        <th style={{ fontSize: '13px' }} key={v}>
                          {v.title}
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody style={{ width: '100%' }} className="overflow-y-auto">
                  {data.map((item) => {
                    return (
                      <tr key={item.name} style={{ width: '100%' }}>
                        {allCloumns.map((v) => {
                          const obj = item.data.find(
                            (f) => f.name === v.title || f.name === v.slug
                          )

                          return (
                            <td
                              key={v}
                              style={{ maxWidth: '200px', fontSize: '13px' }}
                            >
                              {item[v.slug || v.title] || obj.value}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Index
